import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=48fa2973&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseTouchScroll: require('/home/vsts/work/1/a/NuxtApp/components/base/TouchScroll.vue').default})
